var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftalarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftalarm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 3,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 26h43a16.07 16.07 0 1 1-15.48 12h-21.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 2v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.03 9.03l5.66 5.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.97 9.03l-5.66 5.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 36a6 6 0 1 1 0 12 6 6 0 1 1 0-12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftalarm);
export default __webpack_public_path__ + "static/media/leftalarm.25e5b10a2bcf8d5b9e8969e5f2f2e9e9.svg";
export { ForwardRef as ReactComponent };